import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { HelpDisplayService } from '../../services/help-display.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-help-overlay',
  imports: [ButtonModule],
  template: `
      <div class="flex-col h-full">
        <div class="absolute top-14 right-6">
          <p-button class="ml-auto" label="Close Help" icon="pi pi-times" [raised]="true" severity="primary" (onClick)="close()"/>
        </div>
        <iframe [src]="helpUri" width="100%" height="100%" style="height: calc(100%)"></iframe>
      </div>
  `,
  styles: ``
})
export class HelpOverlayComponent {

    helpUri: SafeResourceUrl;

    constructor(private help: HelpDisplayService, private sanitizer: DomSanitizer) {
      this.helpUri = this.sanitizer.bypassSecurityTrustResourceUrl(help.uri());
    }

    close() {
      this.help.hide();
    }
}
